/** 在图片中心放置扩展变形画布，画布节点由会话组件创建与销毁 */
import type React from 'react';
import type { ILayerProps } from '@/version-types';

/** 预览画布为图片宽高的两倍，为向外拖动控制点预留空间 */
export const StageWidthScale = 2;

const RenderStage: React.FC<{
    scale: number;
    activeLayer: ILayerProps;
    canvasHostRef: React.RefObject<HTMLDivElement>;
}> = ({ scale, activeLayer, canvasHostRef }) => (
    <div className="c-deformation-img-render-stage">
        <div
            ref={canvasHostRef}
            style={{
                width: activeLayer.width * StageWidthScale,
                height: activeLayer.height * StageWidthScale,
                transform: `scale(${scale})`,
                transformOrigin: 'center center',
            }}
        />
    </div>
);

export default RenderStage;
